module.exports = __webpack_public_path__ + "static/media/router-min.dfa859c3.jpg";